import { useEffect, useRef, useCallback } from 'react';
import { sendHeartbeat as apiSendHeartbeat } from '../services/api';

export const useHeartbeat = (
  sessionId: string | null,
  apiUrl: string,
  debug: boolean = false
) => {
  const heartbeatIntervalRef = useRef<number | null>(null);
  const log = useCallback((...args: unknown[]) => {
    if (debug) {
      console.log('[RemstalVoice:useHeartbeat]', ...args);
    }
  }, [debug]);

  const stopHeartbeat = useCallback(() => {
    if (heartbeatIntervalRef.current) {
      window.clearInterval(heartbeatIntervalRef.current);
      heartbeatIntervalRef.current = null;
      log('Heartbeat stopped');
    }
  }, [log]);

  const startHeartbeat = useCallback(() => {
    stopHeartbeat(); // Ensure no multiple intervals running
    if (sessionId) {
      log('Starting heartbeat for session:', sessionId);

      // Send first heartbeat immediately
      apiSendHeartbeat(apiUrl, sessionId).catch(error => {
        log('Initial heartbeat failed:', error);
      });

      // Send heartbeat every 30 seconds
      heartbeatIntervalRef.current = window.setInterval(() => {
        apiSendHeartbeat(apiUrl, sessionId).catch(error => {
          log('Heartbeat failed:', error);
        });
      }, 30000);
    }
  }, [sessionId, apiUrl, log, stopHeartbeat]);

  useEffect(() => {
    startHeartbeat();
    return () => stopHeartbeat();
  }, [sessionId, startHeartbeat, stopHeartbeat]);
};
